export const DEFAULT_CANVAS_FILL_PERCENTAGE = 100;

export function normalizeCanvasFillPercentage(value, fallback = DEFAULT_CANVAS_FILL_PERCENTAGE)
{
	const numeric = Number(value);
	if (!Number.isFinite(numeric))
		return fallback;

	return Math.min(Math.max(Math.round(numeric), 1), 100);
}

export function normalizeCanvasConfig(rawConfig, fallbackConfig = null)
{
	const source = rawConfig && typeof rawConfig === "object" ? rawConfig : {};
	const fallback = fallbackConfig && typeof fallbackConfig === "object" ? fallbackConfig : {};
	const width = Number(source.width ?? fallback.width);
	const height = Number(source.height ?? fallback.height);

	return {
		width: Number.isFinite(width) && width > 0 ? Math.round(width) : null,
		height: Number.isFinite(height) && height > 0 ? Math.round(height) : null,
		fill: typeof source.fill === "string"
			? source.fill
			: (typeof fallback.fill === "string" ? fallback.fill : "#ffffff"),
		transparency: typeof source.transparency === "boolean"
			? source.transparency
			: (typeof fallback.transparency === "boolean" ? fallback.transparency : true),
		fillPercentage: normalizeCanvasFillPercentage(source.fillPercentage ?? fallback.fillPercentage)
	};
}

export function getCanvasAutoComposition(imgW, imgH, rawCanvasConfig)
{
	const canvasConfig = normalizeCanvasConfig(rawCanvasConfig);
	const canvasW = Number(canvasConfig.width);
	const canvasH = Number(canvasConfig.height);

	if (!canvasW || !canvasH || !imgW || !imgH)
		return null;

	const containScale = Math.min(canvasW / imgW, canvasH / imgH);
	const scaleFactor = containScale * (canvasConfig.fillPercentage / 100);
	const width = Math.max(1, Math.round(imgW * scaleFactor));
	const height = Math.max(1, Math.round(imgH * scaleFactor));

	return {
		x: Math.round((canvasW - width) / 2),
		y: Math.round((canvasH - height) / 2),
		width,
		height
	};
}
